import { ReactNode } from 'react';
import reactStringReplace from 'react-string-replace';

import { YEAR_REGEX } from '@monoimin/constants';
import { flagSizes } from '@monoimin/sb-types';
import { handleReplaceFlag } from '@monoimin/atoms/components/image/utils/handleReplaceFlag';

import { getYearForReplacement } from './getYearForReplacement';

const forceArray = (el: any) => (Array.isArray(el) ? el : [el]);

const handleReplaceYearNode = ({ children }: { children: ReactNode }) =>
  reactStringReplace(forceArray(children), YEAR_REGEX, () =>
    getYearForReplacement()
  );

// порядок функций важен
const marksHandlers = [handleReplaceYearNode, handleReplaceFlag];

export const newRenderWithMarks = ({
  children,
  ...props
}: {
  children: ReactNode;
  className?: string;
  size?: flagSizes;
}) => {
  return forceArray(children).map((childrenElement: ReactNode) => {
    return marksHandlers.reduce<ReactNode>(
      (acc, handler) => handler({ ...props, children: acc }),
      childrenElement
    );
  });
};
